import { render, staticRenderFns } from "./TDSButton.vue?vue&type=template&id=7c3a50d0&scoped=true&"
import script from "./TDSButton.vue?vue&type=script&lang=ts&"
export * from "./TDSButton.vue?vue&type=script&lang=ts&"
import style0 from "./TDSButton.vue?vue&type=style&index=0&id=7c3a50d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a50d0",
  null
  
)

export default component.exports